import { BugoBrandBrief } from '@shared/api/bugoBrand/bugoBrand.interface';
import { getAgencyBrandName } from '@shared/utils/bugoBrandName.util';

/**
 * 상조 표기명 해석기 — **순수 모듈**.
 *
 * 조회 훅(`useAnalyticsBrandNames`)은 axios를 끌고 오므로 집계 유틸이 그걸 직접
 * import하면 순수 유틸 테스트까지 axios 목이 필요해진다. 그래서 타입과 해석 함수만
 * 여기 따로 둔다.
 *
 * 왜 해석기를 두는가: 통계 조회는 수천~수만 문서를 받는데 거기에 `bugoBrand`를
 * populate하면 `bugoAgencyList`(지사 목록)가 **문서마다 통째로 복사**된다. 정작 쓰는 건
 * 표기명 한 줄뿐이라, 상조 목록을 한 번만 받아 두고 이름은 프론트에서 붙인다.
 * 그룹 키(`brandKeyOf`)는 원래 id + index만 쓰므로 populate가 없어도 그대로 동작한다.
 *
 * 부하 진단·전환 계획: `docs/admin-analytics-load-and-api-decision.md`
 */
export type BrandNameResolver = (
  brand: BugoBrandBrief | string | null | undefined,
  index?: number,
) => string;

export const UNKNOWN_BRAND_NAME = '(상조 미지정)';

/** populate된 문서를 그대로 쓰는 기본 해석기 — 이름 맵이 없을 때의 동작 */
export const defaultBrandNameResolver: BrandNameResolver = (brand, index) =>
  getAgencyBrandName(brand, index) || UNKNOWN_BRAND_NAME;

export const brandIdOf = (brand: BugoBrandBrief | string | null | undefined): string =>
  !brand ? '' : typeof brand === 'string' ? brand : brand._id;

/** 이름 맵 기반 해석기. 맵에 없으면 문서에 붙어온 값으로 떨어진다 */
export const brandNameResolverOf =
  (map: Map<string, BugoBrandBrief>): BrandNameResolver =>
  (brand, index) => {
    const found = map.get(brandIdOf(brand));
    return getAgencyBrandName(found ?? brand, index) || UNKNOWN_BRAND_NAME;
  };
